import { useMutation } from '@apollo/client';
import { CheckIcon } from '@heroicons/react/20/solid';
import { ACTION_ACCOUNT_CREDIT_CARD_DEFAULT } from '@retainerclub/shared-api';
import PropTypes from 'prop-types';

function ActionDefaultAccountCreditCard({
  id,
  refetch = null,
  defaultCard = false,
  isExpired = false,
}) {
  const [actionDefault] = useMutation(ACTION_ACCOUNT_CREDIT_CARD_DEFAULT);

  async function handleActionDefault() {
    try {
      const params = {
        variables: {
          input: {
            id,
            clientMutationId: crypto.randomUUID(),
          },
        },
      };

      const { data } = await actionDefault(params);

      const { accountCreditCard } = data.actionAccountCreditCardDefault;

      if (accountCreditCard && refetch) {
        refetch();
      }
    } catch (err) {
      console.error(err);
    }
  }

  return !(defaultCard || isExpired) ? (
    <button
      type="button"
      className={`-ml-px relative inline-flex items-center ${defaultCard ? 'rounded-md' : 'rounded-l-md'} bg-white px-3 py-2 font-semibold text-gray-900 text-sm ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-10`}
      onClick={() => handleActionDefault()}
    >
      <CheckIcon className="size-4" aria-hidden="true" />
    </button>
  ) : null;
}

ActionDefaultAccountCreditCard.propTypes = {
  id: PropTypes.string.isRequired,
  refetch: PropTypes.func,
  defaultCard: PropTypes.bool,
  isExpired: PropTypes.bool,
};

export default ActionDefaultAccountCreditCard;
